import { useNavigate } from "react-router-dom";
import AppLogoWhite from "../../../../assets/images/app-logo-white.png";

const IPhone18ProBanner = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full h-full bg-[#000] text-white relative">
      {/* TEXT */}
      <div className="absolute bottom-4 left-4 right-4 lg:bottom-8 lg:left-16 lg:right-16 flex flex-row justify-between items-center">
        <div className="text-left space-y-2 lg:space-y-2">
          <h1 className="text-2xl lg:text-5xl font-bold">iPhone 18 Pro</h1>
          <p className="text-sm lg:text-2xl text-gray-300">PRO HƠN HẲN.</p>
        </div>
        <div className="text-center lg:text-left space-y-2 lg:space-y-2">
          <button
            onClick={() => navigate(`/products/iPhone/iphone-18-pro`)}
            className="px-6 py-3 border border-[#A01F3B] rounded-md text-[#A01F3B] hover:bg-[#A01F3B] hover:text-black transition"
          >
            Mua ngay
          </button>
          <p className="text-xs text-gray-300 italic">* Hỗ trợ TRẢ GÓP</p>
        </div>
      </div>
      <div className="w-full h-full overflow-hidden">
        {/* Mobile: < lg */}
        <video
          id="welcome-video-mobile"
          aria-label="iPhone 17 Pro, màu Cam Vũ Trụ…"
          className="block lg:hidden w-full h-full object-cover object-[center_30%]"
          muted
          playsInline
          autoPlay
          loop
          preload="none"
          poster="https://res.cloudinary.com/dyxwbtohw/image/upload/v1789374400/hero_endframe__fbxsnz8txcia_small_2x_cozkp2.jpg"
        >
          <source
            src="https://res.cloudinary.com/dyxwbtohw/video/upload/v1789373811/small_2x_rfns1t.mp4"
            type="video/mp4"
          />
        </video>

        {/* Desktop: >= lg */}
        <video
          id="welcome-video-desktop"
          aria-label="iPhone 17 Pro, màu Cam Vũ Trụ…"
          className="hidden lg:block w-full h-full object-cover object-[center_30%]"
          muted
          playsInline
          autoPlay
          loop
          preload="none"
          poster="https://res.cloudinary.com/dyxwbtohw/image/upload/v1789373641/hero_endframe__fbxsnz8txcia_medium_2x_w5wjyy.jpg"
        >
          <source
            src="https://res.cloudinary.com/dyxwbtohw/video/upload/v1789371178/medium_2x_uelttt.mp4"
            type="video/mp4"
          />
        </video>
      </div>

      {/* Logo */}
      <div className="absolute top-6 left-8 lg:top-12 lg:left-16 flex gap-2 items-center">
        <img src={AppLogoWhite} className="w-10 h-10" alt="Logo" />
        <div className="flex flex-col gap-0.5">
          <span className="text-md lg:text-xl font-bold">Ly iPhone</span>
          <span className="text-xs font-bold text-gray-400">
            253 Hùng Vương, Tam Kỳ
          </span>
        </div>
      </div>
    </div>
  );
};
export default IPhone18ProBanner;
